import { render, staticRenderFns } from "./history-trashed-clients.vue?vue&type=template&id=1eb2f922"
import script from "./history-trashed-clients.vue?vue&type=script&lang=js"
export * from "./history-trashed-clients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports